import { useState, useCallback } from 'react';
import { Form } from 'components';
import { useParams } from 'react-router-dom';
import { useRejectDealMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export const useRejectDeal = () => {
  const [form] = Form.useForm();
  const { id } = useParams() as { id: string };
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [rejectDeal, { isLoading }] = useRejectDealMutation();
  const { handleSuccess, handleError } = useNotificationMessages();

  const showModal = useCallback(() => {
    setIsModalVisible(true);
  }, []);

  const hideModal = useCallback(() => {
    setIsModalVisible(false);
    form.resetFields();
  }, [form]);

  const handleSubmit = useCallback(async () => {
    try {
      const values = await form.validateFields();

      const result = await rejectDeal({
        dealId: id,
        rejectionReason: values.rejectionReason,
        additionalInformation: values.additionalInformation,
      });

      if ('error' in result) {
        handleError('Failed to reject deal');
        return;
      }

      handleSuccess('Deal was successfully rejected.');
      hideModal();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  }, [form, rejectDeal, id, hideModal, handleSuccess, handleError]);

  return {
    form,
    isModalVisible,
    isLoading,
    showModal,
    hideModal,
    handleSubmit,
  };
};
